(function($) {
  const $nav = $('.aw-selection-nav');
  const $inner = $('.aw-selection-nav__inner');
  const $header = $('.section-header');

  if (!$nav.length || !$inner.length || !$header.length) return;

  let lastScrollY = window.scrollY;
  let headerHeight = $header.outerHeight();
  let headerHidden = false;

  function updateHeader(currentScrollY, scrollingDown) {
    if (scrollingDown && currentScrollY > 0 && !headerHidden) {
      $header.css('transform', `translateY(-${headerHeight}px)`);
      headerHidden = true;
    } else if (!scrollingDown && currentScrollY <= 0 && headerHidden) {
      $header.css('transform', 'translateY(0)');
      headerHidden = false;
    }
  }

  function updateNav(currentScrollY, scrollingDown) {
    $nav.css('min-height', $inner.outerHeight());

    const navOffsetTop = $nav.offset().top;

    if (scrollingDown && !$inner.hasClass('is-fixed')) {
      if (navOffsetTop <= currentScrollY) {
        $inner.addClass('is-fixed').css({
          position: 'fixed',
          top: 0,
          left: $nav.offset().left,
          width: $nav.outerWidth()
        });
      }
    } else if (!scrollingDown && $inner.hasClass('is-fixed')) {
      if (navOffsetTop >= currentScrollY) {
        $inner.removeClass('is-fixed').css({
          position: 'relative',
          top: '',
          left: '',
          width: ''
        });
      }
    }
  }

  function adjustNavOffset() {
    if ($inner.hasClass('is-fixed')) {
      const topOffset = headerHidden ? 0 : headerHeight;
      $inner.css('top', topOffset);
    }
  }

  function init() {
    headerHeight = $header.outerHeight();
    const currentScrollY = window.scrollY;

    if (currentScrollY > 0) {
      $header.css({ transition: 'none', transform: `translateY(-${headerHeight}px)` });
      headerHidden = true;
      setTimeout(() => $header.css('transition', 'transform 0.3s ease'), 0);
    } else {
      $header.css({ transition: 'transform 0.3s ease', transform: 'translateY(0)' });
      headerHidden = false;
    }

    $nav.css('min-height', $inner.outerHeight());
    const navOffsetTop = $nav.offset().top;

    if (navOffsetTop <= currentScrollY) {
      $inner.addClass('is-fixed').css({
        position: 'fixed',
        top: 0,
        left: $nav.offset().left,
        width: $nav.outerWidth()
      });
      adjustNavOffset();
    }

    lastScrollY = currentScrollY;
  }

  $(window).on('scroll', function() {
    const currentScrollY = window.scrollY;
    const scrollingDown = currentScrollY > lastScrollY;

    updateHeader(currentScrollY, scrollingDown);
    updateNav(currentScrollY, scrollingDown);
    adjustNavOffset();

    lastScrollY = currentScrollY;
  });

  $(window).on('resize', function() {
    headerHeight = $header.outerHeight();
    $nav.css('min-height', $inner.outerHeight());

    if ($inner.hasClass('is-fixed')) {
      $inner.css({
        left: $nav.offset().left,
        width: $nav.outerWidth()
      });
    }

    adjustNavOffset();
  });

  init();

})(jQuery);

document.addEventListener('DOMContentLoaded', function() {
  var navInner = document.querySelector('.aw-selection-nav__inner');
  if (!navInner) return;

  var allDetails = navInner.querySelectorAll('details');
  var openDetails = null;
  var MOBILE_BREAKPOINT = 768;

  function isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  function positionSubmenu(details) {
    var submenu = details.querySelector(':scope > .submenu');
    if (!submenu) return;

    var navRect = navInner.getBoundingClientRect();

    submenu.style.position = 'fixed';
    submenu.style.top = navRect.bottom + 'px';
    submenu.style.zIndex = '1000';

    if (isMobile()) {
      // SP：navInnerの左端固定
      submenu.style.left = navRect.left + 'px';
    } else {
      // PC：summaryの中央基準
      var summaryRect = details.querySelector('summary').getBoundingClientRect();
      var submenuWidth = submenu.offsetWidth;
      var left = summaryRect.left + summaryRect.width / 2 - submenuWidth / 2;
      submenu.style.left = left + 'px';
    }
  }

  allDetails.forEach(function(details) {
    details.addEventListener('toggle', function() {
      if (details.open) {
        if (openDetails && openDetails !== details) {
          openDetails.open = false;
        }
        openDetails = details;
        positionSubmenu(details);
      } else {
        if (openDetails === details) {
          openDetails = null;
        }
      }
    });
  });

  window.addEventListener('resize', function() {
    if (openDetails) {
      positionSubmenu(openDetails);
    }
  });

  window.addEventListener('scroll', function() {
    if (openDetails) {
      positionSubmenu(openDetails);
    }
  }, {
    passive: true,
    capture: true
  });

  navInner.addEventListener('scroll', function() {
    if (openDetails) {
      positionSubmenu(openDetails);
    }
  }, {
    passive: true
  });
});
